module.exports = __webpack_public_path__ + "img/kirby_pp.4e74dd07.jpg";